<template>
    <ResourceInput
        label="Title"
        attribute="title"
    />
</template>
